module.exports = __webpack_public_path__ + "static/media/Jacob Karson Headshot.a08a56e5.jpeg";